export default __webpack_public_path__ + "f32a49b7151816d01bda24ac7117dc70.png";